'use client';

import React from 'react';
import { ShoppingBagDrawer, useCartDrawer } from '@skin-seoul/shared-components';
import { useSafeRouter } from '@/hooks/useSafeRouter';
import NextImage from 'next/image';
import HeaderClient from './Header.client';
import { useRegionCurrency } from '@skin-seoul/service';
import { SafeLink } from '@/components/ui/SafeLink';
const Header = () => {
  const {
    country,
    currency
  } = useRegionCurrency();
  const {
    onCartClose
  } = useCartDrawer();
  const {
    push
  } = useSafeRouter();
  const handleContinueShopping = () => {
    onCartClose();
    push('/');
  };
  const ImageWrapper = ({
    src,
    alt,
    width,
    height
  }: {
    src: string;
    alt: string;
    width: number;
    height: number;
  }) => <NextImage src={src} alt={alt} width={width} height={height} data-sentry-element="NextImage" data-sentry-component="ImageWrapper" data-sentry-source-file="Header.tsx" />;
  return <>
      <ShoppingBagDrawer currency={currency} onClickContinueShopping={handleContinueShopping} ImageComponent={ImageWrapper} linkComponent={SafeLink} data-sentry-element="ShoppingBagDrawer" data-sentry-source-file="Header.tsx" />
      <HeaderClient country={country} data-sentry-element="HeaderClient" data-sentry-source-file="Header.tsx" />
    </>;
};
export default Header;